import { mapState } from 'vuex'
import api from '../../api/checkout'
import checkoutStepBase from '../checkoutStepBase'

export default {
    mixins: [checkoutStepBase],

    data() {
        return {
            data: null,
            acceptTerms: false,
            triedToSubmit: false,
            submitIsDisabled: false
        }
    },

    computed: {
        ...mapState('cart', [
            'items',
            'price',
            'shippable'
        ]),

        selectedShippingModeHasPickupPoints() {
            if (!this.checkoutData.shippingModes) {
                return false
            }
            const shippingMode = this.data.userData.shipping_mode
            const selectedShippingMode = this.checkoutData.shippingModes.find(el => el.id === shippingMode)
            return selectedShippingMode && selectedShippingMode.pickupPoints && selectedShippingMode.pickupPoints !== null
        },

        selectedPickupPointData() {
            const shippingMode = this.data.userData.shipping_mode
            const selectedShippingMode = this.checkoutData.shippingModes.find(el => el.id === shippingMode)
            const pickupPointId = this.data.userData.pickup_point_id
            return selectedShippingMode.pickupPoints.find(el => el.id === pickupPointId)
        },

        phoneNumber() {
            return `+${this.data.userData.phone_number.country_code}`
                + this.data.userData.phone_number.prefix
                + this.data.userData.phone_number.line_number
        },

        paymentFee() {
            if (! this.data) {
                return 0
            }

            if (this.price.gross + this.data.shippingCost < 0) {
                return this.price.gross + this.data.shippingCost + this.data.paymentFee
            }

            return this.data.paymentFee
        },

        shippingCost() {
            if (! this.data) {
                return 0
            }

            if (this.price.gross < 0) {
                return this.price.gross + this.data.shippingCost
            }

            return this.data.shippingCost
        }
    },

    methods: {
        async fetch() {
            try {
                const response = await api.summary()
                this.data = response.data

                this.$bus.$emit('summary-loaded')
            } catch (error) {
                this.$bus.$emit('summary-error', error)
            }
        },

        submitForm() {
            if ( !this.acceptTerms ) {
                this.triedToSubmit = true
            } else {
                this.submitIsDisabled = true
                this.$refs.form.submit()
            }
        }
    },

    watch: {
        currentComponent(value) {
            if (value === 'summary-step') {
                this.fetch()
            }
        }
    }
}
